<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="分销员名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入订单编号/用户名称/手机号搜索"></el-input>
          </el-form-item>
          <el-form-item label="时间筛选：" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="佣金状态">
            <template slot-scope="scope">
              <span>{{scope.row.status == 2 ? '待入账' : '已入账'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="realPayMoney"
            label="订单金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="firstCommissionMoney"
            label="一级分润金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoCommissionMoney"
            label="二级分润金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderCreateTime"
            width="130"
            label="下单时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryUserCommissionOrderPageList } from '@/api/commission'
export default {
  name: 'CommissionMember',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        date: ['', '']
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let userId = that.dataId
      let page = that.currentPage
      queryUserCommissionOrderPageList({ webCommissionSearchStr: searchName, startDate: startDate, endDate: endDate, userId: userId,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/CommissionOrder.vue